import React from 'react';
import { Edit, TextInput, SimpleForm } from 'react-admin';

const templateCategoryEdit = props => {
    const validate = values => {
        const errors: any = {};

        if (!values.name) {
            errors.name = ['Name is required'];
        }

        return errors;
    };
    return (
        <Edit {...props}>
            <SimpleForm validate={validate} redirect="show">
                <TextInput label="Name" source="name" />
                <TextInput label="Description" source="description" />
            </SimpleForm>
        </Edit>
    );
};

export default templateCategoryEdit;
